import React, { useEffect, useState } from 'react';
import './landing.scss';
import happiLogo from '../assets/happi-logo-image.png';
import QRCode from "react-qr-code";
import { v4 as uuidv4 } from 'uuid';


const new_uid=uuidv4();

const HappiLanding = () => {
  const [uid,setUid]=useState('');
  useEffect(()=>{
    let localUid=localStorage.getItem('uuid');
    if(!localUid){
      localStorage.setItem('uuid',JSON.stringify(new_uid));
      setUid(new_uid)
    }
    if(localUid){
      setUid(JSON.parse(localUid))
    }


  },[])
  return (
    <>
         <div className='bg position-relative'>
          <div className='position-absolute ms-3 mt-3'>
            <img src={happiLogo} alt="happi-logo"  width={"12%"} height={"12%"} loading='lazy'/>
            </div>
    {/* <div className='d-flex align-items-center justify-content-center'> */}
        <div className='d-flex flex-column align-items-center'>
        <QRCode
    size={20}
    style={{ height: "30%",maxHeight: "30%", maxWidth: "40%", width: "40%",marginTop:"30px" }}
    value={uid}
    viewBox={`0 0 150 200`}
  />
        <h3 className='filter-text text-white m-0 fw-bold mt-2'>Please Apply Your Filters in Remote</h3>
        </div>
       
    </div>
    {/* </div> */}
    </>
  )
}

export default HappiLanding
